import {
  SINGLE_OPTION_SELECT,
  MULTIPLE_OPTION_SELECT,
  MONTH_PICKER,
  TREATMENT_HISTORY,
  NUMBER_INPUT,
  BIOMARKERS,
  OPTIONS_FROM_SERVER,
} from 'components/Questionnaire/constants/questionTypes';
import { Profile as ID } from 'components/Questionnaire/cancers/brain/BrainProfile.enum';
import ConditionTypes from 'components/Questionnaire/constants/conditions';
import i from 'components/Questionnaire/constants/icons';
import {
  preferredLocation,
  travelLimit,
  userType,
  dateOfBirth,
  haveInsurance,
  insurance,
  race,
  diseaseStatus,
  pdL1ExpressionByQNumber,
  initialDiagnosisDate,
} from 'components/Questionnaire/constants/globalQuestions';
import {
  yesAndNoOptions, notSureOption, treatmentCyclesOptions,
  // takingStateOptions,
} from 'components/Questionnaire/constants/globalOptions';
import SECTIONS from 'components/Questionnaire/constants/questionSections';
import dateType from 'utils/constants/dateTypes';
import numberType from 'utils/constants/numberTypes';
import { QUESTION_VIEW_TYPES } from 'components/Questionnaire/constants/questionViewTypes';
import GLOBAL_ENUMS from '../../constants/globalEnums';

const { biomarkers: BIOMARKERS_QUESTION_ID } = GLOBAL_ENUMS;
const { OPTIONS_LIST_WITH_SHOW_MORE } = QUESTION_VIEW_TYPES;

const {
  NOT_EQUAL_TO_OR_SKIPPED,
  DOESNT_CONTAIN_ONE_OF_OR_SKIPPED,
  CONTAIN_ONE_OF,
  AGE_LESS_THAN,
  EQUAL_TO,
  CONTAINS_ONE_OF_OR_SKIPPED,
} = ConditionTypes;

const Questions = [
  diseaseStatus,
  {
    q: 'Q5',
    id: ID.brain_cancer_type,
    type: SINGLE_OPTION_SELECT,
    section: SECTIONS.MY_CANCER,
    bgIcon: i.medical_profile,
    order: 0,
    title: 'questionnaire.questions.brain.1_brain_cancer_type.title',

    info: {
      title: 'questionnaire.questions.brain.1_brain_cancer_type.info.title',
      content: 'questionnaire.questions.brain.1_brain_cancer_type.info.content',
    },
    options: [
      {
        label: 'questionnaire.questions.brain.1_brain_cancer_type.options.gbm',
        value: 'gbm',
      },
      {
        label: 'questionnaire.questions.brain.1_brain_cancer_type.options.dmg_dipg',
        value: 'dmg_dipg',
      },
      {
        label: 'questionnaire.questions.brain.1_brain_cancer_type.options.grade_1_astro',
        value: 'grade_1_astro',
      },
      {
        label: 'questionnaire.questions.brain.1_brain_cancer_type.options.grade_2_astro',
        value: 'grade_2_astro',
      },
      {
        label: 'questionnaire.questions.brain.1_brain_cancer_type.options.grade_3_astro',
        value: 'grade_3_astro',
      },
      {
        label: 'questionnaire.questions.brain.1_brain_cancer_type.options.grade_2_oligo',
        value: 'grade_2_oligo',
      },
      {
        label: 'questionnaire.questions.brain.1_brain_cancer_type.options.grade_3_oligo',
        value: 'grade_3_oligo',
      },
    ],
    conditions: [],
    isRequired: true,
  },
  {
    q: 'Q7',
    id: ID.tumor_surgery,
    type: SINGLE_OPTION_SELECT,
    section: SECTIONS.MY_CANCER,
    bgIcon: '',
    order: 0,
    title: 'questionnaire.questions.brain.3_tumor_surgery.title',

    info: {
      title: '',
      content: '',
    },
    options: [
      {
        label: 'questionnaire.questions.brain.3_tumor_surgery.options.yes',
        value: 'yes',
      },
      {
        label: 'questionnaire.questions.brain.3_tumor_surgery.options.no',
        value: 'no',
      },
    ],
    conditions: [],
  },
  {
    q: 'Q12',
    id: ID.treatment_for_brain_cancer,
    type: SINGLE_OPTION_SELECT,
    section: SECTIONS.TREATMENT,
    bgIcon: i.treatment,
    order: 0,
    title: 'questionnaire.questions.brain.13_treatment_for_brain_cancer.title',

    info: {
      title: 'questionnaire.questions.brain.13_treatment_for_brain_cancer.info.title',
      content: 'questionnaire.questions.brain.13_treatment_for_brain_cancer.info.content',
    },
    options: yesAndNoOptions,
    conditions: [
      {
        ifId: ID.tumor_surgery,
        type: NOT_EQUAL_TO_OR_SKIPPED,
        ifValue: 'no',
      },
    ],
    isRequired: true,
  },
  {
    q: 'Q8',
    id: ID.measurable_tumor,
    type: SINGLE_OPTION_SELECT,
    section: SECTIONS.MY_CANCER,
    bgIcon: '',
    order: 0,
    title: 'questionnaire.questions.brain.5_measurable_tumor.title',

    info: {
      title: 'questionnaire.questions.brain.5_measurable_tumor.info.title',
      content: 'questionnaire.questions.brain.5_measurable_tumor.info.content',
    },
    options: [
      ...yesAndNoOptions,
      {
        label: 'questionnaire.questions.brain.5_measurable_tumor.options.disease_measurable',
        value: 'disease_measurable',
      },
      notSureOption,
    ],
    conditions: [],
    isRequired: true,
  },
  {
    q: 'Q7a',
    id: ID.last_surgery_date,
    type: MONTH_PICKER,
    section: SECTIONS.MY_CANCER,
    bgIcon: i,
    order: 0,
    title: 'questionnaire.questions.brain.4_last_surgery_date.title',

    info: {
      title: '',
      content: '',
    },
    options: [],
    conditions: [
      {
        ifId: ID.tumor_surgery,
        type: NOT_EQUAL_TO_OR_SKIPPED,
        ifValue: 'no',
      },
    ],
    dateType: {
      type: dateType.stopTreatment,
    },
  },
  {
    q: 'Q8a',
    id: ID.brain_tumor_size_mm,
    type: NUMBER_INPUT,
    section: SECTIONS.MY_CANCER,
    bgIcon: i.cancer_research,
    order: 0,
    title: 'questionnaire.questions.brain.6_brain_tumor_size_mm.title',
    subtitle: 'questionnaire.questions.brain.6_brain_tumor_size_mm.subtitle',
    info: {
      title: '',
      content: '',
    },
    options: [],
    conditions: [
      {
        ifId: ID.measurable_tumor,
        type: EQUAL_TO,
        ifValue: 'yes',
      },
    ],
    instruction: 'questionnaire.questions.brain.6_brain_tumor_size_mm.instruction',
    numberType: numberType.int,
  },
  {
    q: 'Q9',
    id: ID.brain_cancer_characteristics,
    type: MULTIPLE_OPTION_SELECT,
    section: SECTIONS.MY_CANCER,
    bgIcon: i.cancer_research,
    order: 0,
    title: 'questionnaire.questions.brain.7_brain_cancer_characteristics.title',
    subtitle: 'questionnaire.questions.brain.7_brain_cancer_characteristics.subtitle',
    info: {
      title: 'questionnaire.questions.brain.7_brain_cancer_characteristics.info.title',
      content: 'questionnaire.questions.brain.7_brain_cancer_characteristics.info.content',
    },
    options: [
      {
        label: 'questionnaire.questions.brain.7_brain_cancer_characteristics.options.multifocal',
        value: 'multifocal',
      },
      {
        label: 'questionnaire.questions.brain.7_brain_cancer_characteristics.options.tumor_hemorrhage',
        value: 'tumor_hemorrhage',
      },
      {
        label: 'questionnaire.questions.brain.7_brain_cancer_characteristics.options.leptomeningeal_disease',
        value: 'leptomeningeal_disease',
      },
      {
        label: 'questionnaire.questions.brain.7_brain_cancer_characteristics.options.infratentorial_disease',
        value: 'infratentorial_disease',
      },
      {
        label: 'questionnaire.questions.brain.7_brain_cancer_characteristics.options.spinal_cord',
        value: 'spinal_cord',
      },
      {
        label: 'questionnaire.questions.brain.7_brain_cancer_characteristics.options.extracranial',
        value: 'extracranial',
      },
      {
        label: 'questionnaire.questions.brain.7_brain_cancer_characteristics.options.none',
        value: 'none',
        exclusive: true,
      },
    ],
    conditions: [],
    isRequired: true,
  },
  {
    q: 'Q10',
    id: ID.has_biopsy,
    type: SINGLE_OPTION_SELECT,
    section: SECTIONS.MY_CANCER,
    bgIcon: i.molecular,
    order: 0,
    title: 'questionnaire.questions.brain.8_has_biopsy.title',

    info: {
      title: 'questionnaire.questions.brain.8_has_biopsy.info.title',
      content: 'questionnaire.questions.brain.8_has_biopsy.info.content',
    },
    options: [
      {
        label: 'questionnaire.questions.brain.8_has_biopsy.options.yes',
        value: 'yes',
      },
      {
        label: 'questionnaire.questions.brain.8_has_biopsy.options.no',
        value: 'no',
      },
      {
        label: 'questionnaire.questions.brain.8_has_biopsy.options.biopsy_possible',
        value: 'biopsy_possible',
      },
    ],
    conditions: [],
    isRequired: true,
  },
  {
    q: 'Q90',
    id: ID.pd_l1_carrier_status,
    type: SINGLE_OPTION_SELECT,
    section: SECTIONS.MY_CANCER,
    bgIcon: i.molecular,
    order: 0,
    title: 'questionnaire.questions.brain.33_pd_l1_carrier_status.title',
    info: {
      title: 'questionnaire.questions.brain.33_pd_l1_carrier_status.info.title',
      content: 'questionnaire.questions.brain.33_pd_l1_carrier_status.info.content',
    },
    options: [
      {
        label: 'questionnaire.questions.brain.33_pd_l1_carrier_status.options.positive',
        value: 'yes',
      },
      {
        label: 'questionnaire.questions.brain.33_pd_l1_carrier_status.options.negative',
        value: 'no',
      },
      {
        label: 'questionnaire.questions.brain.33_pd_l1_carrier_status.options.not_sure',
        value: 'not_sure',
      },
    ],
    conditions: [
      {
        ifId: ID.has_biopsy,
        type: DOESNT_CONTAIN_ONE_OF_OR_SKIPPED,
        ifValue: ['no', 'biopsy_possible'],
      },
    ],
  },
  pdL1ExpressionByQNumber('Q90a'),
  {
    q: 'Q80',
    id: ID.ngs,
    type: SINGLE_OPTION_SELECT,
    section: SECTIONS.TREATMENT,
    bgIcon: i.molecular,
    order: 0,
    title: 'questionnaire.questions.brain.32_ngs.title',
    info: {
      title: '',
      content: '',
    },
    options: [
      {
        label: 'questionnaire.questions.brain.32_ngs.options.yes',
        value: 'yes',
      },
      {
        label: 'questionnaire.questions.brain.32_ngs.options.yes_waiting_for_the_results',
        value: 'yes_waiting_for_the_results',
      },
      {
        label: 'questionnaire.questions.brain.32_ngs.options.no',
        value: 'no',
      },
      {
        label: 'questionnaire.questions.brain.32_ngs.options.no_but_planning',
        value: 'no_but_planning',
      },
    ],
    conditions: [],
  },
  {
    q: 'Q10a',
    id: ID.mgmt_status,
    type: SINGLE_OPTION_SELECT,
    section: SECTIONS.MY_CANCER,
    bgIcon: '',
    order: 0,
    title: 'questionnaire.questions.brain.9_mgmt_status.title',

    info: {
      title: 'questionnaire.questions.brain.9_mgmt_status.info.title',
      content: 'questionnaire.questions.brain.9_mgmt_status.info.content',
    },
    options: [
      {
        label: 'questionnaire.questions.brain.9_mgmt_status.options.methylated',
        value: 'methylated',
      },
      {
        label: 'questionnaire.questions.brain.9_mgmt_status.options.unmethylated',
        value: 'unmethylated',
      },
      {
        label: 'questionnaire.questions.brain.9_mgmt_status.options.indeterminate',
        value: 'indeterminate',
      },
      {
        label: 'questionnaire.questions.brain.9_mgmt_status.options.na',
        value: 'na',
      },
      notSureOption,
    ],
    conditions: [
      {
        ifId: ID.has_biopsy,
        type: DOESNT_CONTAIN_ONE_OF_OR_SKIPPED,
        ifValue: ['no', 'biopsy_possible'],
      },
      {
        ifId: ID.brain_cancer_type,
        type: DOESNT_CONTAIN_ONE_OF_OR_SKIPPED,
        ifValue: ['grade_1_astro', 'grade_2_astro', 'grade_2_oligo', 'grade_2_oligo'],
      },
    ],
  },
  {
    q: 'Q10b',
    id: BIOMARKERS_QUESTION_ID,
    type: BIOMARKERS,
    section: SECTIONS.MY_CANCER,
    bgIcon: i.molecular,
    order: 0,
    title: 'questionnaire.questions.brain.10_biomarkers.title',
    subtitle: 'questionnaire.questions.brain.10_biomarkers.subtitle',
    placeholder: 'questionnaire.questions.biomarkers.placeholder',
    info: {
      title: '',
      content: '',
    },
    conditions: [
      {
        ifId: ID.has_biopsy,
        type: CONTAINS_ONE_OF_OR_SKIPPED,
        ifValue: ['yes'],
      },
    ],
  },
  {
    q: 'Q11',
    id: ID.brain_radiation,
    type: SINGLE_OPTION_SELECT,
    section: SECTIONS.TREATMENT,
    bgIcon: '',
    order: 0,
    title: 'questionnaire.questions.brain.11_brain_radiation.title',

    info: {
      title: 'questionnaire.questions.brain.11_brain_radiation.info.title',
      content: 'questionnaire.questions.brain.11_brain_radiation.info.content',
    },
    options: yesAndNoOptions,
    conditions: [],
  },
  {
    q: 'Q11a',
    id: ID.brain_radiation_date,
    type: MONTH_PICKER,
    section: SECTIONS.TREATMENT,
    bgIcon: i,
    order: 0,
    title: 'questionnaire.questions.brain.12_brain_radiation_date.title',

    info: {
      title: 'questionnaire.questions.brain.12_brain_radiation_date.info.title',
      content: 'questionnaire.questions.brain.12_brain_radiation_date.info.content',
    },
    options: [],
    conditions: [
      {
        ifId: ID.brain_radiation,
        type: EQUAL_TO,
        ifValue: 'yes',
      },
    ],
    dateType: {
      type: dateType.currentDate,
    },
  },
  {
    q: 'Q12a',
    id: ID.tmx_rad_candidate,
    type: SINGLE_OPTION_SELECT,
    section: SECTIONS.TREATMENT,
    bgIcon: i.treatment,
    order: 0,
    title: 'questionnaire.questions.brain.14_tmx_rad_candidate.title',

    info: {
      title: 'questionnaire.questions.brain.14_tmx_rad_candidate.info.title',
      content: 'questionnaire.questions.brain.14_tmx_rad_candidate.info.content',
    },
    options: [...yesAndNoOptions, notSureOption],
    conditions: [
      {
        ifId: ID.disease_status,
        type: NOT_EQUAL_TO_OR_SKIPPED,
        ifValue: 'refractory_disease',
      },
      {
        ifId: ID.brain_cancer_type,
        type: CONTAIN_ONE_OF,
        ifValue: ['gbm', null, undefined], // null - in editing mode, undefined - first attempt (They both mean IS_SKIPPED)
      },
    ],
  },
  {
    q: 'Q60',
    id: ID.treatments,
    type: TREATMENT_HISTORY,
    section: SECTIONS.TREATMENT,
    bgIcon: '',
    order: 0,
    title: 'questionnaire.questions.brain.15_treatments.title',

    requiredSubQuestionsId: [ID.drugs_received],
    footer: 'questionnaire.questions.brain.15_treatments.footer',
    info: {
      title: '',
      content: '',
    },
    submitButtonLabel: 'Add Treatment',
    options: [
      {
        iconText: 'A',
        label: 'questionnaire.questions.brain.15_treatments.options.treatment_name',
        value: null,
      },
      {
        iconText: 'B',
        label: 'questionnaire.questions.brain.15_treatments.options.disease_course',
        value: null,
      },
      {
        iconText: 'C',
        label: 'questionnaire.questions.brain.15_treatments.options.cycles_received',
        value: null,
      },
      {
        iconText: 'D',
        label: 'questionnaire.questions.brain.15_treatments.options.when_treatment_stopped',
        value: null,
      },
      {
        iconText: 'E',
        label: 'questionnaire.questions.brain.15_treatments.options.treatment_stopped_reason',
        value: null,
      },
    ],
    // shouldAutoOpenSubQuestions: [{
    //   ifId: ID.treatment_for_brain_cancer,
    //   type: EQUAL_TO,
    //   ifValue: 'yes',
    // }],
    conditions: [
      {
        ifId: ID.treatment_for_brain_cancer,
        type: NOT_EQUAL_TO_OR_SKIPPED,
        ifValue: 'no',
      },
    ],
    subQuestions: [
      {
        q: 'Q60a',
        id: ID.drugs_received,
        type: OPTIONS_FROM_SERVER,
        viewType: OPTIONS_LIST_WITH_SHOW_MORE,
        section: SECTIONS.TREATMENT,
        bgIcon: i.treatment,
        order: 0,
        titleIconText: 'A',
        title: 'questionnaire.questions.brain.15_treatments.sub_questions.drugs_received.title',
        subtitle: 'questionnaire.questions.brain.15_treatments.sub_questions.drugs_received.subtitle',
        placeholder: 'questionnaire.questions.drugs_received.placeholder',
        info: {
          title: '',
          content: '',
        },
        questionProps: {
          isSearchableByOptionGroupName: true,
        },
      },
      {
        q: 'Q60f',
        id: ID.cycles,
        type: SINGLE_OPTION_SELECT,
        section: SECTIONS.TREATMENT,
        title: 'questionnaire.questions.brain.15_treatments.sub_questions.cycles.title',
        disableNextOnOptionSelect: false,
        options: [...treatmentCyclesOptions],
      },
      {
        q: 'Q60b',
        id: ID.treatment_end_date,
        type: MONTH_PICKER,
        section: SECTIONS.TREATMENT,
        bgIcon: i.treatment,
        order: 0,
        titleIconText: 'B',
        title: 'questionnaire.questions.brain.15_treatments.sub_questions.treatment_end_date.title',
        subtitle: '',
        info: {
          title: '',
          content: '',
        },
        options: [],
        conditions: [],
        dateType: {
          type: dateType.stopTreatment,
        },
      },
      {
        q: 'Q60c',
        id: ID.treatment_stop_reason,
        type: SINGLE_OPTION_SELECT,
        section: SECTIONS.TREATMENT,
        bgIcon: i.treatment,
        order: 0,
        titleIconText: 'C',
        title: 'questionnaire.questions.brain.15_treatments.sub_questions.treatment_stop_reason.title',
        subtitle: '',
        info: {
          title: '',
          content: '',
        },
        disableNextOnOptionSelect: false,
        options: [
          {
            label:
              'questionnaire.questions.brain.15_treatments.sub_questions.treatment_stop_reason.options.treatment_ongoing',
            value: 'treatment_ongoing',
          },
          {
            label:
              'questionnaire.questions.brain.15_treatments.sub_questions.treatment_stop_reason.options.end_of_protocol',
            value: 'end_of_protocol',
          },
          {
            label:
              'questionnaire.questions.brain.15_treatments.sub_questions.treatment_stop_reason.options.progression',
            value: 'progression',
          },
          {
            label:
              'questionnaire.questions.brain.15_treatments.sub_questions.treatment_stop_reason.options.no_response',
            value: 'no_response',
          },
          {
            label:
              'questionnaire.questions.brain.15_treatments.sub_questions.treatment_stop_reason.options.loss_of_response',
            value: 'loss_of_response',
          },
          {
            label: 'questionnaire.questions.brain.15_treatments.sub_questions.treatment_stop_reason.options.remission',
            value: 'remission',
          },
          {
            label: 'questionnaire.questions.brain.15_treatments.sub_questions.treatment_stop_reason.options.toxicity',
            value: 'toxicity',
          },
          {
            label: 'questionnaire.questions.brain.15_treatments.sub_questions.treatment_stop_reason.options.other_medical_conditions',
            value: 'other_medical_conditions',
          },
          {
            label: 'questionnaire.questions.brain.15_treatments.sub_questions.treatment_stop_reason.options.dosing_issues',
            value: 'dosing_issues',
          },
          {
            label: 'questionnaire.questions.brain.15_treatments.sub_questions.treatment_stop_reason.options.scheduling',
            value: 'scheduling',
          },
          {
            label: 'questionnaire.questions.brain.15_treatments.sub_questions.treatment_stop_reason.options.travel_limitation',
            value: 'travel_limitation',
          },
          {
            label: 'questionnaire.questions.brain.15_treatments.sub_questions.treatment_stop_reason.options.financial_reasons_or_insurance',
            value: 'financial_reasons_or_insurance',
          },
          {
            label: 'questionnaire.questions.brain.15_treatments.sub_questions.treatment_stop_reason.options.other',
            value: 'other',
          },
        ],
        conditions: [],
      },
    ],
    // title: '',
    // info: {
    //   title: '',
    //   content: '',
    // },
    // footer: '',
    // type: TREATMENT_HISTORY,
    // section: SECTIONS.TREATMENT,
    // bgIcon: '',
    // order: 0,
    // subQuestionsIds: [
    //   ID.drugs_received,
    //   ID.treatment_stop_reason,
    // ],
    // conditions: [
    //   {
    //     ifId: ID.treatment_for_brain_cancer,
    //     type: NOT_EQUAL_TO_OR_SKIPPED,
    //     ifValue: 'no',
    //   },
    // ],
    // options: [],
    // subQuestionsOptions: {
    //   treatment_stop_reason: [
    //     {
    //       label:
    //         'questionnaire.questions.treatment_stop_reason.options.no_response',
    //       value: 'no_response',
    //     },
    //     {
    //       label:
    //         'questionnaire.questions.treatment_stop_reason.options.end_of_protocol',
    //       value: 'end_of_protocol',
    //     },
    //     {
    //       label: 'questionnaire.questions.treatment_stop_reason.options.toxicity',
    //       value: 'toxicity',
    //     },
    //     {
    //       label:
    //         'questionnaire.questions.treatment_stop_reason.options.progression',
    //       value: 'progression',
    //     },
    //     {
    //       label:
    //         'questionnaire.questions.treatment_stop_reason.options.loss_of_response',
    //       value: 'loss_of_response',
    //     },
    //     {
    //       label: 'questionnaire.questions.treatment_stop_reason.options.remission',
    //       value: 'remission',
    //     },
    //     {
    //       label: 'questionnaire.questions.treatment_stop_reason.options.other',
    //       value: 'other',
    //     },
    //   ],
    //   taking_state: takingStateOptions,
    // },

  },
  {
    q: 'Q13',
    id: ID.intratumoral_therapy,
    type: SINGLE_OPTION_SELECT,
    section: SECTIONS.TREATMENT,
    bgIcon: '',
    order: 0,
    title: 'questionnaire.questions.brain.16_intratumoral_therapy.title',

    info: {
      title: '',
      content: '',
    },
    options: yesAndNoOptions,
    conditions: [
      {
        ifId: ID.treatment_for_brain_cancer,
        type: NOT_EQUAL_TO_OR_SKIPPED,
        ifValue: 'no',
      },
    ],
    isRequired: true,
  },
  {
    q: 'Q45',
    id: ID.ecog,
    type: SINGLE_OPTION_SELECT,
    section: SECTIONS.MY_HEALTH,
    bgIcon: i.doctor_book_kit,
    order: 0,
    title: 'questionnaire.questions.brain.17_ecog.title',

    info: {
      title: 'questionnaire.questions.brain.17_ecog.info.title',
      content: 'questionnaire.questions.brain.17_ecog.info.content',
    },
    options: [
      {
        label: 'questionnaire.questions.brain.17_ecog.options.0',
        value: '0',
      },
      {
        label: 'questionnaire.questions.brain.17_ecog.options.1',
        value: '1',
      },
      {
        label: 'questionnaire.questions.brain.17_ecog.options.2',
        value: '2',
      },
      {
        label: 'questionnaire.questions.brain.17_ecog.options.3',
        value: '3',
      },
      {
        label: 'questionnaire.questions.brain.17_ecog.options.4',
        value: '4',
      },
    ],
    conditions: [],
    isRequired: true,
  },
  {
    q: 'Q46',
    id: ID.other_medical_condition,
    type: MULTIPLE_OPTION_SELECT,
    section: SECTIONS.MY_HEALTH,
    bgIcon: i.doctor_book_kit,
    order: 0,
    title: 'questionnaire.questions.brain.18_other_medical_condition.title',

    info: {
      title: '',
      content: '',
    },
    options: [
      {
        label: 'questionnaire.questions.brain.18_other_medical_condition.options.no_other_health_issues',
        value: 'no_other_health_issues',
        exclusive: true,
      },
      {
        label: 'questionnaire.questions.brain.18_other_medical_condition.options.liver',
        value: 'liver',
      },
      {
        label: 'questionnaire.questions.brain.18_other_medical_condition.options.heart',
        value: 'heart',
      },
      {
        label: 'questionnaire.questions.brain.18_other_medical_condition.options.kidney',
        value: 'kidney',
      },
      {
        label: 'questionnaire.questions.brain.18_other_medical_condition.options.autoimmune',
        value: 'autoimmune',
      },
      {
        label: 'questionnaire.questions.brain.18_other_medical_condition.options.mental',
        value: 'mental',
      },
      {
        label: 'questionnaire.questions.brain.18_other_medical_condition.options.allergies',
        value: 'allergies',
      },
      {
        label: 'questionnaire.questions.brain.18_other_medical_condition.options.chronic_infection_or_inflammation',
        value: 'chronic_infection_or_inflammation',
      },
      {
        label: 'questionnaire.questions.brain.18_other_medical_condition.options.gastrointestinal',
        value: 'gastrointestinal',
      },
      {
        label: 'questionnaire.questions.brain.18_other_medical_condition.options.other_cancer_type',
        value: 'other_cancer_type',
      },
      {
        label: 'questionnaire.questions.brain.18_other_medical_condition.options.anemia',
        value: 'anemia',
      },
      {
        label: 'questionnaire.questions.brain.18_other_medical_condition.options.thyroid',
        value: 'thyroid',
      },
      {
        label: 'questionnaire.questions.brain.18_other_medical_condition.options.hypertension',
        value: 'hypertension',
      },
      {
        label: 'questionnaire.questions.brain.18_other_medical_condition.options.epilepsy',
        value: 'epilepsy',
      },
      {
        label: 'questionnaire.questions.brain.18_other_medical_condition.options.diabetes',
        value: 'diabetes',
      },
      {
        label: 'questionnaire.questions.brain.18_other_medical_condition.options.organ_transplant',
        value: 'organ_transplant',
      },
      {
        label: 'questionnaire.questions.brain.18_other_medical_condition.options.hsct',
        value: 'hsct',
      },
      {
        label: 'questionnaire.questions.brain.18_other_medical_condition.options.extreme_obesity',
        value: 'extreme_obesity',
      },
      {
        label: 'questionnaire.questions.brain.18_other_medical_condition.options.stroke',
        value: 'stroke',
      },
      {
        label: 'questionnaire.questions.brain.18_other_medical_condition.options.lung',
        value: 'lung',
      },
      {
        label: 'questionnaire.questions.brain.18_other_medical_condition.options.neuropathy',
        value: 'neuropathy',
      },
    ],
    conditions: [],
  },
  {
    q: 'Q46a',
    id: ID.omc_liver,
    type: SINGLE_OPTION_SELECT,
    section: SECTIONS.MY_HEALTH,
    bgIcon: i.doctor_book_kit,
    order: 0,
    title: 'questionnaire.questions.brain.19_omc_liver.title',

    info: {
      title: '',
      content: '',
    },
    options: [
      {
        label: 'questionnaire.questions.brain.19_omc_liver.options.elevated_alt_ast',
        value: 'elevated_alt_ast',
      },
      {
        label: 'questionnaire.questions.brain.19_omc_liver.options.elevated_bilirubin',
        value: 'elevated_bilirubin',
      },
      {
        label: 'questionnaire.questions.brain.19_omc_liver.options.cirrhosis',
        value: 'cirrhosis',
      },
      {
        label: 'questionnaire.questions.brain.19_omc_liver.options.other',
        value: 'other',
      },
    ],
    conditions: [
      {
        ifId: ID.other_medical_condition,
        type: CONTAIN_ONE_OF,
        ifValue: ['liver'],
      },
    ],
  },
  {
    q: 'Q46b',
    id: ID.omc_heart,
    type: SINGLE_OPTION_SELECT,
    section: SECTIONS.MY_HEALTH,
    bgIcon: i.doctor_book_kit,
    order: 0,
    title: 'questionnaire.questions.brain.20_omc_heart.title',

    info: {
      title: '',
      content: '',
    },
    options: [
      {
        label: 'questionnaire.questions.brain.20_omc_heart.options.class_at_least_nyha_ii',
        value: 'class_at_least_nyha_ii',
      },
      {
        label: 'questionnaire.questions.brain.20_omc_heart.options.condition_at_least_grade_2',
        value: 'condition_at_least_grade_2',
      },
      {
        label: 'questionnaire.questions.brain.20_omc_heart.options.cardiac_ventricular_arrhythmia',
        value: 'cardiac_ventricular_arrhythmia',
      },
      {
        label: 'questionnaire.questions.brain.20_omc_heart.options.heart_failure',
        value: 'heart_failure',
      },
      {
        label: 'questionnaire.questions.brain.20_omc_heart.options.lvef_under_50_percent',
        value: 'lvef_under_50_percent',
      },
      {
        label: 'questionnaire.questions.brain.20_omc_heart.options.qtcf_abnormal',
        value: 'qtcf_abnormal',
      },
      {
        label: 'questionnaire.questions.brain.20_omc_heart.options.angina',
        value: 'angina',
      },
      {
        label: 'questionnaire.questions.brain.20_omc_heart.options.myocardial_infarction',
        value: 'myocardial_infarction',
      },
      {
        label: 'questionnaire.questions.brain.20_omc_heart.options.pacemaker',
        value: 'pacemaker',
      },
    ],
    conditions: [
      {
        ifId: ID.other_medical_condition,
        type: CONTAIN_ONE_OF,
        ifValue: ['heart'],
      },
    ],
  },
  {
    q: 'Q46c',
    id: ID.omc_stroke_date,
    type: MONTH_PICKER,
    section: SECTIONS.MY_HEALTH,
    bgIcon: i.doctor_book_kit,
    order: 0,
    title: 'questionnaire.questions.brain.21_omc_stroke_date.title',

    info: {
      title: '',
      content: '',
    },
    conditions: [
      {
        ifId: ID.other_medical_condition,
        type: CONTAIN_ONE_OF,
        ifValue: ['stroke'],
      },
    ],
    dateType: {
      type: dateType.stopTreatment,
    },
  },
  {
    q: 'Q46d',
    id: ID.omc_kidney,
    type: SINGLE_OPTION_SELECT,
    section: SECTIONS.MY_HEALTH,
    bgIcon: i.doctor_book_kit,
    order: 0,
    title: 'questionnaire.questions.brain.22_omc_kidney.title',

    info: {
      title: '',
      content: '',
    },
    options: [
      {
        label: 'questionnaire.questions.brain.22_omc_kidney.options.low_glomerular_filtration_rate',
        value: 'low_glomerular_filtration_rate',
      },
      {
        label: 'questionnaire.questions.brain.22_omc_kidney.options.dialysis',
        value: 'dialysis',
      },
      {
        label: 'questionnaire.questions.brain.22_omc_kidney.options.kidney_stones',
        value: 'kidney_stones',
      },
      {
        label: 'questionnaire.questions.brain.22_omc_kidney.options.creatinine_high',
        value: 'creatinine_high',
      },
      {
        label: 'questionnaire.questions.brain.22_omc_kidney.options.other',
        value: 'other',
      },
    ],
    conditions: [
      {
        ifId: ID.other_medical_condition,
        type: CONTAIN_ONE_OF,
        ifValue: ['kidney'],
      },
    ],
  },
  {
    q: 'Q46e',
    id: ID.omc_autoimmune,
    type: SINGLE_OPTION_SELECT,
    section: SECTIONS.MY_HEALTH,
    bgIcon: i.doctor_book_kit,
    order: 0,
    title: 'questionnaire.questions.brain.23_omc_autoimmune.title',

    info: {
      title: '',
      content: '',
    },
    options: [
      {
        label: 'questionnaire.questions.brain.23_omc_autoimmune.options.congenital_or_acquired_immunosuppression',
        value: 'congenital_or_acquired_immunosuppression',
      },
      {
        label: 'questionnaire.questions.brain.23_omc_autoimmune.options.hepatitis',
        value: 'hepatitis',
      },
      {
        label: 'questionnaire.questions.brain.23_omc_autoimmune.options.granulomatous_disease',
        value: 'granulomatous_disease',
      },
      {
        label: 'questionnaire.questions.brain.23_omc_autoimmune.options.hormone_replacement_therapy_disease',
        value: 'hormone_replacement_therapy_disease',
      },
    ],
    conditions: [
      {
        ifId: ID.other_medical_condition,
        type: CONTAIN_ONE_OF,
        ifValue: ['autoimmune'],
      },
    ],
  },
  {
    q: 'Q46f',
    id: ID.omc_mental,
    type: SINGLE_OPTION_SELECT,
    section: SECTIONS.MY_HEALTH,
    bgIcon: i.doctor_book_kit,
    order: 0,
    title: 'questionnaire.questions.brain.24_omc_mental.title',

    info: {
      title: '',
      content: '',
    },
    options: [
      {
        label: 'questionnaire.questions.brain.24_omc_mental.options.dementia',
        value: 'dementia',
      },
      {
        label: 'questionnaire.questions.brain.24_omc_mental.options.neuropsychyatric',
        value: 'neuropsychyatric',
      },
      {
        label: 'questionnaire.questions.brain.24_omc_mental.options.depression',
        value: 'depression',
      },
    ],
    conditions: [
      {
        ifId: ID.other_medical_condition,
        type: CONTAIN_ONE_OF,
        ifValue: ['mental'],
      },
    ],
  },
  {
    q: 'Q46g',
    id: ID.omc_chronic_infection_inflammation,
    type: SINGLE_OPTION_SELECT,
    section: SECTIONS.MY_HEALTH,
    bgIcon: i.doctor_book_kit,
    order: 0,
    title: 'questionnaire.questions.brain.25_omc_chronic_infection_inflammation.title',

    info: {
      title: '',
      content: '',
    },
    options: [
      {
        label: 'questionnaire.questions.brain.25_omc_chronic_infection_inflammation.options.hepatitis',
        value: 'hepatitis',
      },
      {
        label: 'questionnaire.questions.brain.25_omc_chronic_infection_inflammation.options.hiv',
        value: 'hiv',
      },
      {
        label: 'questionnaire.questions.brain.25_omc_chronic_infection_inflammation.options.other',
        value: 'other',
      },
      {
        label: 'questionnaire.questions.brain.25_omc_chronic_infection_inflammation.options.uncontrolled_infection',
        value: 'uncontrolled_infection',
      },
    ],
    conditions: [
      {
        ifId: ID.other_medical_condition,
        type: CONTAIN_ONE_OF,
        ifValue: ['chronic_infection_or_inflammation'],
      },
    ],
  },
  {
    q: 'Q46h',
    id: ID.omc_gastro_problem,
    type: SINGLE_OPTION_SELECT,
    section: SECTIONS.MY_HEALTH,
    bgIcon: i.doctor_book_kit,
    order: 0,
    title: 'questionnaire.questions.brain.26_omc_gastro_problem.title',

    info: {
      title: '',
      content: '',
    },
    options: [
      {
        label: 'questionnaire.questions.brain.26_omc_gastro_problem.options.gastrointestinal_bleeding',
        value: 'gastrointestinal_bleeding',
      },
      {
        label: 'questionnaire.questions.brain.26_omc_gastro_problem.options.crohns',
        value: 'crohns',
      },
      {
        label: 'questionnaire.questions.brain.26_omc_gastro_problem.options.colitis',
        value: 'colitis',
      },
      {
        label: 'questionnaire.questions.brain.26_omc_gastro_problem.options.other',
        value: 'other',
      },
    ],
    conditions: [
      {
        ifId: ID.other_medical_condition,
        type: CONTAIN_ONE_OF,
        ifValue: ['gastrointestinal'],
      },
    ],
  },
  {
    q: 'Q46i',
    id: ID.omc_lung_disease,
    type: SINGLE_OPTION_SELECT,
    section: SECTIONS.MY_HEALTH,
    bgIcon: i.doctor_book_kit,
    order: 0,
    title: 'questionnaire.questions.brain.27_omc_lung_disease.title',

    info: {
      title: '',
      content: '',
    },
    options: [
      {
        label: 'questionnaire.questions.brain.27_omc_lung_disease.options.interstitial_lung_disease',
        value: 'interstitial_lung_disease',
      },
      {
        label: 'questionnaire.questions.brain.27_omc_lung_disease.options.pneumonitis',
        value: 'pneumonitis',
      },
      {
        label: 'questionnaire.questions.brain.27_omc_lung_disease.options.dyspnea',
        value: 'dyspnea',
      },
      {
        label: 'questionnaire.questions.brain.27_omc_lung_disease.options.tuberculosis',
        value: 'tuberculosis',
      },
      {
        label: 'questionnaire.questions.brain.27_omc_lung_disease.options.other',
        value: 'other',
      },
    ],
    conditions: [
      {
        ifId: ID.other_medical_condition,
        type: CONTAIN_ONE_OF,
        ifValue: ['lung'],
      },
    ],
  },
  {
    q: 'Q15',
    id: ID.omc_abnormal_blood_results,
    type: MULTIPLE_OPTION_SELECT,
    section: SECTIONS.MY_HEALTH,
    bgIcon: i.doctor_book_kit,
    order: 0,
    title: 'questionnaire.questions.brain.28_omc_abnormal_blood_results.title',
    subtitle: 'questionnaire.questions.brain.28_omc_abnormal_blood_results.subtitle',
    info: {
      title: '',
      content: '',
    },
    options: [
      {
        label: 'questionnaire.questions.brain.28_omc_abnormal_blood_results.options.none',
        value: 'none',
        exclusive: true,
      },
      {
        label: 'questionnaire.questions.brain.28_omc_abnormal_blood_results.options.low_wbc',
        value: 'low_wbc',
      },
      {
        label: 'questionnaire.questions.brain.28_omc_abnormal_blood_results.options.low_hemoglobin',
        value: 'low_hemoglobin',
      },
      {
        label: 'questionnaire.questions.brain.28_omc_abnormal_blood_results.options.low_neutrophil_count',
        value: 'low_neutrophil_count',
      },
      {
        label: 'questionnaire.questions.brain.28_omc_abnormal_blood_results.options.low_platelet_count',
        value: 'low_platelet_count',
      },
      {
        label: 'questionnaire.questions.brain.28_omc_abnormal_blood_results.options.low_potassium',
        value: 'low_potassium',
      },
      {
        label: 'questionnaire.questions.brain.28_omc_abnormal_blood_results.options.low_magnesium',
        value: 'low_magnesium',
      },
      {
        label: 'questionnaire.questions.brain.28_omc_abnormal_blood_results.options.elevated_alt_ast',
        value: 'elevated_alt_ast',
      },
      {
        label: 'questionnaire.questions.brain.28_omc_abnormal_blood_results.options.creatinine_high',
        value: 'creatinine_high',
      },
    ],
    conditions: [],
  },
  {
    q: 'Q16',
    id: ID.other_medications,
    type: MULTIPLE_OPTION_SELECT,
    section: SECTIONS.MY_HEALTH,
    bgIcon: i.doctor_book_kit,
    order: 0,
    title: 'questionnaire.questions.brain.29_other_medications.title',
    subtitle: 'questionnaire.questions.brain.29_other_medications.subtitle',
    info: {
      title: '',
      content: '',
    },
    options: [
      {
        label: 'questionnaire.questions.brain.29_other_medications.options.immunosuppressive_medications',
        value: 'immunosuppressive_medications',
      },
      {
        label: 'questionnaire.questions.brain.29_other_medications.options.anticonvulsants',
        value: 'anticonvulsants',
      },
      {
        label: 'questionnaire.questions.brain.29_other_medications.options.anticoagulants',
        value: 'anticoagulants',
      },
      {
        label: 'questionnaire.questions.brain.29_other_medications.options.none',
        value: 'none',
        exclusive: true,
      },
    ],
    conditions: [],
  },
  initialDiagnosisDate('Q6'),
  userType,
  dateOfBirth,
  {
    q: 'Q4',
    id: ID.gender,
    type: SINGLE_OPTION_SELECT,
    section: SECTIONS.ABOUT_ME,
    bgIcon: i.medical_profile,
    order: 0,
    title: 'questionnaire.questions.brain.0_gender.title',
    info: {
      title: '',
      content: '',
    },
    options: [
      {
        label: 'questionnaire.questions.brain.0_gender.options.female',
        value: 'female',
      },
      {
        label: 'questionnaire.questions.brain.0_gender.options.male',
        value: 'male',
      },
      {
        label: 'questionnaire.questions.brain.0_gender.options.NS',
        value: 'NS',
      },
    ],
    conditions: [],
  },
  {
    q: 'Q17',
    id: ID.is_pregnant,
    type: SINGLE_OPTION_SELECT,
    section: SECTIONS.ABOUT_ME,
    bgIcon: i.medical_profile,
    order: 0,
    title: 'questionnaire.questions.brain.30_is_pregnant.title',

    info: {
      title: 'questionnaire.questions.brain.30_is_pregnant.info.title',
      content: 'questionnaire.questions.brain.30_is_pregnant.info.content',
    },
    options: yesAndNoOptions,
    conditions: [
      {
        ifId: ID.gender,
        type: CONTAIN_ONE_OF,
        ifValue: ['female'],
      },
      {
        type: AGE_LESS_THAN,
        ifValue: 50,
      },
    ],
  },
  {
    q: 'Q18',
    id: ID.is_breastfeeding,
    type: SINGLE_OPTION_SELECT,
    section: SECTIONS.ABOUT_ME,
    bgIcon: i.medical_profile,
    order: 0,
    title: 'questionnaire.questions.brain.31_is_breastfeeding.title',

    info: {
      title: 'questionnaire.questions.brain.31_is_breastfeeding.info.title',
      content: 'questionnaire.questions.brain.31_is_breastfeeding.info.content',
    },
    options: yesAndNoOptions,
    conditions: [
      {
        ifId: ID.gender,
        type: CONTAIN_ONE_OF,
        ifValue: ['female'],
      },
      {
        type: AGE_LESS_THAN,
        ifValue: 50,
      },
    ],
  },
  race,
  haveInsurance,
  insurance,
  preferredLocation,
  travelLimit,
];

export default Questions;
